/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminbypasson2Inputs */

const en_adminbypasson2 = /** @type {(inputs: Adminbypasson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass on`)
};

const de_adminbypasson2 = /** @type {(inputs: Adminbypasson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass aktiv`)
};

/**
* | output |
* | --- |
* | "Bypass on" |
*
* @param {Adminbypasson2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminbypasson2 = /** @type {((inputs?: Adminbypasson2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminbypasson2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminbypasson2(inputs)
	return de_adminbypasson2(inputs)
});
export { adminbypasson2 as "adminBypassOn" }